export const number = {
  is_custom: {
    own: 'Припаркованный',
    rent: 'В аренду'
  },
  type: {
    local: 'Локальный',
    toll_free: 'Бесплатный',
    mobile: 'Мобильный',
    national: 'Национальный'
  },

  status: {
    stand_by: 'Не активен',
    active: 'Активный',
    deactivated: 'Деактивирован',
    canceled: 'Отменен',
    on_deactivation: 'На деактивации'
  },

  is_spam: {
    yes: 'Спам',
    no: 'Верифицирован'
  },

  state: {
    direction_to_pbx_error: 'Ошибка направления на АТС',
    direction_to_pbx_pending: 'Направляется на АТС',
    direction_to_pbx_success: 'Направлен на АТС',
    direction_to_number_verification: 'Направлен на верификацию'
  },

  computed_confirmation_type: {
    support: 'Обратитесь в поддержку',
    required_documents: 'Требуются документы',
    need_verification: 'Документы на модерации',
    allow_buying: 'Зарезервировать'
  },

  field: {
    number: 'Номер',
    country: 'Страна',
    region: 'Регион',
    type: 'Тип',
    purchased_at: 'Дата покупки',
    activated_at: 'Дата активации',
    is_spam: 'Спам-база',
    destinations: 'Направления',
    connection_cost: 'Стоимость подключения',
    subscription_fee: 'Абонентская плата',
    minutes_cost: 'Стоимость минуты',
    allow_sms: 'SMS',
    state: 'Используется',
    deactivated_at: 'Дата деактивации',
    capabilities: 'Возможности',
    current_status: 'Текущий статус',
  },

  action: {
    deactivate: 'Деактивировать',
    connect_pbx: 'Направить на АТС',
    stats: 'Статистика'
  },

  modal: {
    deactivate: {
      content: 'Вы действительно хотите деактивировать телефонный номер {number}?'
    },

    connect_pbx: {
      content:
        '<p>Вы действительно хотите направить на АТС телефонный номер {number}?</p>Номер после подключения станет доступен в течении нескольких часов.'
    },

    buy: {
      content:
        '<p>Вы действительно хотите зарезервировать номер телефона {number}? <br> Стоимость подключения - {connection_cost}, <br> стоимость абонентской платы - {subscription_fee}.</p>'
    },

    required_documents: {
      content: '<p>Для покупки телефонного номера {number} необходимо загрузить документы.</p>'
    },

    add_custom: {
      title: 'Добавить свой номер',
      field: {
        code: {
          title: 'Код'
        }
      },
      button: {
        send: 'Отправить',
        check: 'Проверить',
        save: 'Сохранить'
      },
      error: {
        duplicate: 'Номер уже существует'
      }
    }
  },

  days_until_payment:
    '0 дней до оплаты | {count} день до оплаты | {count} дня до оплаты | {count} дней до оплаты',

  badge: {
    total_active: 'Активных номеров',
    total: 'Всего номеров',
    fee: 'Абонентская плата'
  },

  tooltips: {
    fee:
      'Общая стоимость по абонентской плате за все текущие активные номера.',
    all_number_period:
      'Входят номера в любом статусе, дата активации которых была не позже окончания периода.',
    cost_period:
      'Сумма всех транзакций оплаты абонентской платы, дата которых входит в ранж периода.',
    average_period:
      'Сумма оплат по абонентской плате, деленная на количество списаний.'
  }
};
